<template>
  <v-app>

    <v-app-bar app color="primary white--text" height="70">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="white"/>
        <v-img src="../../assets/images/Bliks_branco.png" max-width="60" class="ml-4 titleIMG" contain/>
        <v-spacer/>
        <v-card
          flat
          class="financeiro-status-card"
          :class="{ 'financeiro-status-atraso': financeiroStatus.vencido }"
        >
          <span class="financeiro-status-titulo">Situação Financeira</span>
          <span class="financeiro-status-mensagem">{{ financeiroStatus.mensagem }}</span>
        </v-card>
        <!-- <v-img src="../../assets/images/logo_ekloos_branco.png" max-width="120" class="mx-2 titleIMG hide" contain/> -->
                
        <v-menu offset-y transition="slide-y-transition" max-width="200px">

          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon class="mr-2 mt-2">
              <v-avatar dark color="toolbar">
                <img v-if="sessionApp.foto" :src="`data:image/jpeg;base64,${sessionApp.foto}`">
                <v-icon v-else size="32" dark>mdi-account-circle</v-icon>
              </v-avatar>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item>
              <v-list-item-title>{{sessionApp.usuarioNome}}</v-list-item-title>
            </v-list-item>
            <v-divider/>
            <v-list-item v-if="sessionApp.usuarioNome == 'MASTER'" @click="AbrirAdministrativo()">
              <v-list-item-icon><v-icon>mdi-account-cog</v-icon></v-list-item-icon>
              <v-list-item-title>Administrativo</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="sessionApp.temaEscuro" @click="MudarTema()">
              <v-list-item-icon><v-icon>mdi-invert-colors-off</v-icon></v-list-item-icon>
              <v-list-item-title>Tema Claro</v-list-item-title>
            </v-list-item>
            <v-list-item v-else @click="MudarTema()">
              <v-list-item-icon><v-icon>mdi-invert-colors</v-icon></v-list-item-icon>
              <v-list-item-title>Tema Escuro</v-list-item-title>
            </v-list-item>
            <v-list-item @click="AlterarSenha()">
              <v-list-item-icon><v-icon>mdi-lock-reset</v-icon></v-list-item-icon>
              <v-list-item-title>Alterar Senha</v-list-item-title>
            </v-list-item>
            <v-list-item @click="Logout()">
              <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item>
          </v-list>

        </v-menu>

    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed temporary width="300">
      <v-list nav dense>
        <v-subheader>MENU</v-subheader>
        <v-list-item-group active-class="blue-grey--text text--accent-4">
          <v-list-item to="/principal">
            <v-list-item-icon> <v-icon>mdi-home</v-icon> </v-list-item-icon>
            <v-list-item-content> <v-list-item-title>Principal</v-list-item-title> </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-img class="ma-2" src="../../assets/images/ONG.png" max-width="70px" contain/>

        <v-list-group prepend-icon="mdi-chart-areaspline">
          <template v-slot:activator>
            <v-list-item-title>Projetos</v-list-item-title>
          </template>

          <div v-for="(item, index) in projetoMenuButtons" :key="index">
            <v-tooltip right :disabled="!item.restrito">
              <template v-slot:activator="{on, attrs}">
                <div v-bind="attrs" v-on="on">
                  <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                </div>
              </template>
              <span>Restrito ao seu usuário ou plano.</span>
            </v-tooltip>
          </div>

        <v-list-group sub-group >
          <template v-slot:activator>
            <v-list-item-title>Monitoramento</v-list-item-title>
          </template>

            <div v-for="(item, index) in projetoMonitoramentoMenuButtons" :key="index">
              <v-tooltip right :disabled="!item.restrito">
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                  </div>
                </template>
                <span>Restrito ao seu usuário ou plano.</span>
              </v-tooltip>
            </div>

          </v-list-group>
        </v-list-group>

        <v-list-group prepend-icon="mdi-cash">

          <template v-slot:activator>
            <v-list-item-title>Doação</v-list-item-title>
          </template>

          <div v-for="(item, index) in doacaoMenuButtons" :key="index">
            <v-tooltip right :disabled="!item.restrito">
              <template v-slot:activator="{on, attrs}">
                <div v-bind="attrs" v-on="on">
                  <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                </div>
              </template>
              <span>Restrito ao seu usuário ou plano.</span>
            </v-tooltip>
          </div>

        </v-list-group>

        <v-list-group prepend-icon="mdi-finance">
          <template v-slot:activator>
            <v-list-item-title>Financeiro</v-list-item-title>
          </template>

          <v-list-group no-action sub-group value="true">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Contas a Pagar</v-list-item-title>
              </v-list-item-content>
            </template>  

            <div v-for="(item, index) in financeiroPagarMenuButtons" :key="index">
              <v-tooltip right :disabled="!item.restrito">
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                  </div>
                </template>
                <span>Restrito ao seu usuário ou plano.</span>
              </v-tooltip>
            </div>

            <!-- JA ESTAVA COMENTADO -->
            <!-- <v-list-item link>
              <v-list-item-title>Quitação</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-file-download</v-icon></v-list-item-icon>
            </v-list-item> -->
          </v-list-group>
  
          <v-list-group no-action sub-group value="true">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Contas a Receber</v-list-item-title>
              </v-list-item-content>
            </template>  

            <div v-for="(item, index) in financeiroReceberMenuButtons" :key="index">
              <v-tooltip right :disabled="!item.restrito">
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                  </div>
                </template>
                <span>Restrito ao seu usuário ou plano.</span>
              </v-tooltip>
            </div>

            <!-- JA ESTAVA COMENTADO -->
            <!-- <v-list-item link>
              <v-list-item-title>Geração de Recebíveis</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-file-table-box-multiple-outline</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>Baixa de Recebível</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-file-download-outline</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>Envio de Boletos</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-file-send-outline</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>Lançamento Bancário</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-bank-transfer</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>Remessa Bancária</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-bank-transfer-in</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title>Retorno Bancário</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-bank-transfer-out</v-icon></v-list-item-icon>
            </v-list-item> -->

          </v-list-group>

          <v-list-group no-action sub-group value="true">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Tesouraria</v-list-item-title>
              </v-list-item-content>
            </template> 

            <div v-for="(item, index) in financeiroTesourariaMenuButtons" :key="index">
              <v-tooltip right :disabled="!item.restrito">
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                  </div>
                </template>
                <span>Restrito ao seu usuário ou plano.</span>
              </v-tooltip>
            </div>

          </v-list-group>

          <v-list-group no-action sub-group value="true">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Contabilidade</v-list-item-title>
              </v-list-item-content>
            </template>  

            <div v-for="(item, index) in financeiroContabilidadeMenuButtons" :key="index">
              <v-tooltip right :disabled="!item.restrito">
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                  </div>
                </template>
                <span>Restrito ao seu usuário ou plano.</span>
              </v-tooltip>
            </div>

          </v-list-group>
        </v-list-group>

        <v-list-group prepend-icon="mdi-file-document-multiple">
          
          <template v-slot:activator>
            <v-list-item-title>Relatórios</v-list-item-title>
          </template>
          
          <div v-for="(item, index) in relatorioMenuButtons" :key="index">
            <v-tooltip right :disabled="!item.restrito">
              <template v-slot:activator="{on, attrs}">
                <div v-bind="attrs" v-on="on">
                  <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                </div>
              </template>
              <span>Restrito ao seu usuário ou plano.</span>
            </v-tooltip>
          </div>
        
        </v-list-group>

        <v-list-group prepend-icon="mdi-alpha-a-circle">
          <template v-slot:activator>
            <v-list-item-title>Auxiliar</v-list-item-title>
          </template>
          <div v-for="(item, index) in auxiliarMenuButtons" :key="index">
            <v-tooltip right :disabled="!item.restrito">
              <template v-slot:activator="{on, attrs}">
                <div v-bind="attrs" v-on="on">
                  <v-list-item :to="item.path" :disabled="item.restrito" @click="item.alterarSenha ? dialogAlterarSenha = item.alterarSenha() : '' "><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
                </div>
              </template>
              <span>Restrito ao seu usuário ou plano.</span>
            </v-tooltip>
          </div>
        </v-list-group>

        <v-img class="ma-2" src="../../assets/images/CRM.png" max-width="70px" contain/>

        <div v-for="(item, index) in crmMenuButtons" :key="index">
          <v-tooltip right :disabled="!item.restrito">
            <template v-slot:activator="{on, attrs}">
              <div v-bind="attrs" v-on="on">
                <v-list-item :to="item.path" :disabled="item.restrito"><v-list-item-title>{{item.name}}</v-list-item-title><v-list-item-icon><v-icon :disabled="item.restrito">{{item.icon}}</v-icon></v-list-item-icon></v-list-item>
              </div>
            </template>
            <span>Restrito ao seu usuário ou plano.</span>
          </v-tooltip>
        </div>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="error" @click="Logout()">SAIR</v-btn>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px">
          <span style="color: black; font-size: 12px"> Versão - {{GetAppVersion()}} </span>
        </div>
      </template>

    </v-navigation-drawer>

    <v-container class="pa-2 pt-6 mt-12" fluid>
      <slot/>
    </v-container>

    <v-footer color="primary" app>
      <div class="body-2 white--text text-truncate" style="width: 65vw">
        <span class="padSize" style="font-size: 12px">{{sessionApp.empresaNomeCnpjPlano}}</span>
      </div>
      <v-spacer/>
      <div class="font-weight-regular body-2 white--text">
        <span class="padSize" style="font-size: 12px">&copy; {{ new Date().getFullYear() }}</span>
      </div>
    </v-footer>

    <alterar-senha v-model="dialogAlterarSenha" @fechou="dialogAlterarSenha = false"/>
    
    <login-administrativo v-model="dialogAdministrativo" @fechou="dialogAdministrativo = false"/>
    
  </v-app>
</template>

<script>
import UsuarioService from '../../core/services/geral/UsuarioService';

export default {
  data: () => ({
    drawer: false,
    group: null,
    active: false,
    dialog: false,
    sessionApp: {},
    empresaPlano: '',
    crm: '',
    tipoUsuario: '',
    dialogAlterarSenha: false,
    dialogAdministrativo: false,
    projetoMenuButtons: [],
    projetoMonitoramentoMenuButtons: [],
    doacaoMenuButtons: [],
    crmMenuButtons: [],
    financeiroPagarMenuButtons: [],
    financeiroReceberMenuButtons: [],
    financeiroTesourariaMenuButtons: [],
    financeiroContabilidadeMenuButtons: [],
    relatorioMenuButtons: [],
    auxiliarMenuButtons:[],
    permissoes: []
  }),
  watch: {
    group () {
      this.drawer = false
    },
  },
  created(){
    this.sessionApp = JSON.parse(localStorage.sessionApp); 

    const usuarioService = new UsuarioService();
    usuarioService.ObterPorId(this.sessionApp.usuarioId, "Permissoes").then(
      res=>{
        this.permissoes = res.data.permissoes;
      }
    )

    this.empresaPlano = this.sessionApp.plano
    this.crm = this.sessionApp.crm
    this.tipoUsuario = this.sessionApp.usuarioNome
  },
  mounted() {
    if(this.sessionApp.temaEscuro == 0){
      this.$vuetify.theme.dark = false;
    }
    else{
      this.$vuetify.theme.dark = true;
    }
  },
  computed: {
    financeiroStatus(){
      const plano = this.sessionApp && this.sessionApp.plano;

      if(plano == "G" || plano == "E"){
        return {
          mensagem: "Você está utilizando o plano gratuito.",
          vencido: false
        };
      }

      const vencimentoBoleto = this.ParseDateOnly(this.sessionApp && this.sessionApp.vencimentoBoleto);
      if(!vencimentoBoleto){
        return {
          mensagem: "Assinatura em dia.",
          vencido: false
        };
      }

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      if(vencimentoBoleto < hoje){
        const diffMs = hoje.getTime() - vencimentoBoleto.getTime();
        const diasAtraso = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        return {
          mensagem: `Assinatura vencida desde ${this.FormatarData(vencimentoBoleto)} (${diasAtraso} dias). Evite bloqueio.`,
          vencido: true
        };
      }

      return {
        mensagem: "Assinatura em dia.",
        vencido: false
      };
    }
  },
  beforeUpdate() {
    this.CarregarGrid()
  },
  methods:{
    ParseDateOnly(value){
      if(!value){
        return null;
      }

      const data = new Date(value);
      if(Number.isNaN(data.getTime())){
        return null;
      }

      data.setHours(0, 0, 0, 0);
      return data;
    },
    FormatarData(data){
      return data.toLocaleDateString("pt-BR");
    },
    GetAppVersion(){
      const pack = require('../../../package.json');
      return pack.version;
    },
    CarregarGrid(){
      this.projetoMenuButtons = [
        {name:'Beneficiário', icon:'mdi-account-child', path:'/projetos/beneficiario', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadBeneficiario')},
        {name:'Cadastro de Projeto', icon:'mdi-chart-areaspline-variant', path:'/projetos/projeto', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadProjeto')},
        {name:'Recurso Pessoal', icon:'mdi-account-group', path:'/projetos/recursopessoal', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadRecursoPessoal')},
        {name:'Tipo de Projeto', icon:'mdi-chart-line-variant', path:'/projetos/tipoprojeto', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadTipoProjeto')},
        {name:'Frequência', icon:'mdi-account-multiple-check', path:'/projetos/frequencia', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadFrequencia')},
        {name:'Controle de Ocorrências', icon:'mdi-clipboard-text-clock', path:'/projetos/controleocorrencia', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','E']) : this.UsuarioRestrito(['G','B','E']) || this.PermissaoRestrita('CadControleOcorrencia')},
        {name:'Avaliação de Beneficiário', icon:'mdi-star-check', path:'/projetos/avaliacaobeneficiario', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','E']) : this.UsuarioRestrito(['G','B','E']) || this.PermissaoRestrita('CadAvaliacaoBeneficiario')},
      ],
      this.projetoMonitoramentoMenuButtons = [
        // {name:'Atividade', icon:'mdi-chart-line-variant', path:'/projetos/monitoramento/atividade', restrito: this.UsuarioRestrito([])},
        {name:'Indicadores', icon:'mdi-calendar-cursor', path:'/projetos/monitoramento/indicador', restrito: this.UsuarioRestrito([])},
        {name:'Fluxo Bancário (Extrato)', icon:'mdi-format-list-numbered-rtl', path:'/projetos/monitoramento/fluxobancario', restrito: this.UsuarioRestrito([])},
      ],
      this.doacaoMenuButtons = [
        {name:'Doador', icon:'mdi-account-cash', path:'/doacao/doador', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadDoador')},
        {name:'Relacionamento', icon:'mdi-play-network', path:'/doacao/relacionamento', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadRelacionamento')},
        {name:'Região/Gupo', icon:'mdi-earth-box', path:'/doacao/regiao', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B']) : this.UsuarioRestrito(['G','B']) || this.PermissaoRestrita('CadRegiao')},
      ],
      this.crmMenuButtons = [
        {name:'Captação', icon:'mdi-binoculars', path:'/doacao/oportunidade', restrito: this.crm == 'N'},
        {name:'Atividades', icon:'mdi-calendar-check', path:'/crm/atividades', restrito: this.crm == 'N'},
        {name:'Doador', icon:'mdi-account-cash', path:'/doacao/doador', restrito: this.crm == 'N'},
      ]
      this.financeiroPagarMenuButtons= [
        {name:'Fornecedor', icon:'mdi-account-tie', path:'/financeiro/fornecedor', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G']) : this.UsuarioRestrito(['G']) || this.PermissaoRestrita('CadFornecedor')},
        {name:'Doc. (Compromissos)', icon:'mdi-cash-minus', path:'/financeiro/compromisso', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G']) : this.UsuarioRestrito(['G']) || this.PermissaoRestrita('CadCompromissos')},
      ],
      this.financeiroReceberMenuButtons= [
        {name:'Documentos (Recebíveis)', icon:'mdi-cash-plus', path:'/financeiro/recebivel', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadRecebiveis')},
        {name:'Envio de Boleto', icon:'mdi-barcode', path:'/financeiro/envioboleto', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('EnvioBoletos')},
        {name:'Nota Fiscal de Serviço', icon:'mdi-receipt-text', path:'/fiscal/nfse', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('EnvioBoletos')},
        {name:'Envio de Nota Fiscal de Serviço', icon:'mdi-receipt-text', path:'/fiscal/envionfse', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('EnvioBoletos')},
      ],
      this.financeiroTesourariaMenuButtons= [
        {name:'Banco', icon:'mdi-bank', path:'/financeiro/banco', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G']) : this.UsuarioRestrito(['G'])|| this.PermissaoRestrita('CadBanco')},
        {name:'Plano de Contas', icon:'mdi-file-tree', path:'/financeiro/planoconta', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','E']) : this.UsuarioRestrito(['G','B','E']) || this.PermissaoRestrita('PlanoContasGerencial')},
        {name:'Movimentação Bancária (Extrato)', icon:'mdi-format-list-numbered-rtl', path:'/financeiro/fluxobancario', restrito: this.UsuarioRestrito([]) || this.PermissaoRestrita('LancamentoBancario3')},
        {name:'Conciliação Bancária', icon:'mdi-bank-check', path:'/financeiro/conciliacaoBancaria', restrito: this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('RetornoBancario')},
        {name:'Fechamento do Mês', icon:'mdi-calendar-remove', path:'/financeiro/fechamentomes', restrito: this.UsuarioRestrito([])},
        {name:'Previsão Orçamentária', icon:'mdi mdi-chart-bar-stacked', path:'/financeiro/previsaoOrcamentaria', restrito: this.UsuarioRestrito(['G','B','P','E'])},
      ],
      this.financeiroContabilidadeMenuButtons= [
        {name:'Plano de Contas (Contábil)', icon:'mdi-file-tree-outline', path:'/financeiro/planocontacontabil', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('PlanoContasContabil')},
        {name:'Exportação Contábil', icon:'mdi-file-export-outline', path:'/financeiro/exportacaocontabil', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('PlanoContasContabil')},
      ],
      this.relatorioMenuButtons = [
        {name:'Doador', icon:'mdi-account-cash', path:'/relatorio/configuracao/doador', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelDoador')},
        {name:'Beneficiário', icon:'mdi-account-child', path:'/relatorio/configuracao/beneficiario', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelBeneficiario')},
        {name:'Recurso Pessoal', icon:'mdi-account-group', path:'/relatorio/configuracao/recursopessoal', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelRecursoPessoal')},
        {name:'Acompanhamento de Doações', icon:'mdi-account-cash', path:'/relatorio/configuracao/acompanhamentodoacoes', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelAcompanhamentoDoacoes')},
        {name:'Receita e Despesas dos projetos', icon:'mdi-chart-areaspline', path:'/relatorio/configuracao/receitasdespesasprojetos', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','E']) : this.UsuarioRestrito(['G','B','E']) || this.PermissaoRestrita('RelReceitasDespesasProjetos')},
        {name:'Detalhamento dos Projetos', icon:'mdi-chart-areaspline', path:'/relatorio/configuracao/detalhamentoprojetos', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelProjetoDetalhado')},
        {name:'Balancete Financeiro', icon:'mdi-finance', path:'/relatorio/configuracao/balancetefinanceiro', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B']) : this.UsuarioRestrito(['G','B']) || this.PermissaoRestrita('RelBalanceteFinanceiro')},
        {name:'Fluxo Bancário', icon:'mdi-bank', path:'/relatorio/configuracao/fluxobancario', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G']) : this.UsuarioRestrito(['G'])|| this.PermissaoRestrita('RelFluxoBancario')},
        {name:'Recibo para Doador', icon:'mdi-account-cash', path:'/relatorio/configuracao/recibodoador', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelRecibo')},
        {name:'Frequência', icon:'mdi-account-multiple-check', path:'/relatorio/configuracao/frequencia', restrito: this.UsuarioRestrito([])},
        {name:'Lançamento Contábil', icon:'mdi-file-tree-outline', path:'/relatorio/configuracao/lancamentocontabil', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('RelLancamentoContabil')},
        {name:'Log Utilização', icon:'mdi-file-find', path:'/relatorio/configuracao/logutilizacao', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('RelLog')},
      ],
      this.auxiliarMenuButtons = [        
        {name:'Cadastro de Organização', icon:'mdi-domain', path:'/auxiliar/empresa', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito(['G','B','P','E']) : this.UsuarioRestrito(['G','B','P','E']) || this.PermissaoRestrita('CadEmpresa')},
        {name:'Cadastro de Usuário', icon:'mdi-account', path:'/auxiliar/usuario', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('CadUsuario')},
        {name:'Parâmetros de Sistema', icon:'mdi-cog', path:'/auxiliar/parametroSistema', restrito: this.tipoUsuario == "GESTOR" ? this.UsuarioRestrito([]) : this.UsuarioRestrito([]) || this.PermissaoRestrita('Parametros')},
        {name:'Alterar Senha', icon:'mdi-lock', restrito: this.UsuarioRestrito([]), alterarSenha(){return true}},
      ]
    },
    AbrirAdministrativo(){
      this.dialogAdministrativo = true;
    },
    AlterarSenha(){        
      this.dialogAlterarSenha = true;
    },
    MudarTema(){
      const usuarioService = new UsuarioService();
      usuarioService.MudarTema(this.sessionApp.usuarioId).then(
        res => {
          var session = JSON.parse(localStorage.sessionApp);
          session.temaEscuro = res.data;
          localStorage.setItem('sessionApp', JSON.stringify(session));
          if(res.data == 0)
            this.$vuetify.theme.dark = false;
          else
            this.$vuetify.theme.dark = true;
          this.sessionApp = JSON.parse(localStorage.sessionApp);
        },
        err => this.$swal('Aviso', err.message, 'error')
      )
    },
    UsuarioRestrito(plano){
      if(this.tipoUsuario == "MASTER"){
        return false;
      }
      else{
        if(plano.find(x => x == this.empresaPlano)){
          return true;
        }
        else{
          return false;
        }
      }      
    },
    PermissaoRestrita(permissao){
      if(this.tipoUsuario == "MASTER"){
        return false;
      }
      else{
        if(this.permissoes.find(x => x.menu == permissao)){
          return false;
        }
        else{
          return true;
        }
      }      
    },
    Logout() {
      localStorage.clear();
      this.$vuetify.theme.dark = false;
      this.$router.push({name: 'login'});
    }
  }
}
</script>

<style >
.col-12 {
  padding-top: 5px !important;
  padding-bottom: 0px !important;
}

.financeiro-status-card{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6px 10px;
  margin-right: 20px;
  max-width: 520px;
  min-height: 46px;
  background-color: rgba(46, 204, 113, 0.6) !important;
  color: #ffffff !important;
  border: 1px solid #2ecc71;
  border-radius: 6px;
}

.financeiro-status-atraso{
  background-color: rgba(192, 57, 43, 0.6) !important;
  border-color: #c0392b;
}

.financeiro-status-titulo{
  font-size: 10px;
  line-height: 1.1;
  opacity: 0.9;
}

.financeiro-status-mensagem{
  font-size: 12px;
  line-height: 1.25;
  font-weight: 600;
}

@media only screen and (pointer: coarse){
  .titleIMG{
    width: 15vw;
  }
  .padSize{
    font-size: 85%;
  }
  .hide{
    display: none;
  }
  .financeiro-status-card{
    max-width: 42vw;
    padding: 4px 8px;
  }
  .financeiro-status-titulo{
    font-size: 9px;
  }
  .financeiro-status-mensagem{
    font-size: 10px;
  }
}

</style>
